import { SURF_APP_ID } from "../constants.js";
import { surfGraphQLFetch } from "./httpClient.js";
import { SURF_GRAPHQL } from "./queries.js";
export const SURF_AGENT_MODEL_ID = "global.anthropic.claude-haiku-4-5-20251001-v1:0";
/** Bedrock Converse with image — saliency, autofit, style analyze (must be non-legacy). */
export const SURF_VISION_MODEL_ID = "global.anthropic.claude-sonnet-4-6";
/** Speaker script generation — higher quality long-form spoken copy. */
export const SURF_SPEAKER_SCRIPT_MODEL_ID = SURF_VISION_MODEL_ID;
export const SurfCloudAPI = {
    async ensureProfile(cfg) {
        const idToken = await cfg.getIdToken();
        await surfGraphQLFetch({
            endpoint: cfg.endpoint,
            idToken,
            query: SURF_GRAPHQL.upsertProfile,
            resultKey: "upsertProfile",
        });
    },
    async listNotes(cfg, limit = 40, nextToken) {
        const idToken = await cfg.getIdToken();
        return surfGraphQLFetch({
            endpoint: cfg.endpoint,
            idToken,
            query: SURF_GRAPHQL.listNotes,
            variables: { limit, nextToken },
            resultKey: "listNotes",
        });
    },
    async getNote(cfg, noteId) {
        const idToken = await cfg.getIdToken();
        return surfGraphQLFetch({
            endpoint: cfg.endpoint,
            idToken,
            query: SURF_GRAPHQL.getNote,
            variables: { noteId },
            resultKey: "getNote",
        });
    },
    async submitAIJob(cfg, input) {
        const idToken = await cfg.getIdToken();
        return surfGraphQLFetch({
            endpoint: cfg.endpoint,
            idToken,
            query: SURF_GRAPHQL.submitAIJob,
            variables: {
                input: {
                    appId: SURF_APP_ID,
                    ...input,
                },
            },
            resultKey: "submitAIJob",
        });
    },
    async getAIJob(cfg, jobId) {
        const idToken = await cfg.getIdToken();
        return surfGraphQLFetch({
            endpoint: cfg.endpoint,
            idToken,
            query: SURF_GRAPHQL.getAIJob,
            variables: { jobId },
            resultKey: "getAIJob",
        });
    },
    async listAIJobs(cfg, args) {
        const idToken = await cfg.getIdToken();
        return surfGraphQLFetch({
            endpoint: cfg.endpoint,
            idToken,
            query: SURF_GRAPHQL.listAIJobs,
            variables: {
                appId: args.appId,
                limit: args.limit,
                nextToken: args.nextToken,
            },
            resultKey: "listAIJobs",
        });
    },
};
